import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const IconLink = ({ className , href , iconName , onClick , children ,  })=>/*#__PURE__*/ React.createElement("a", {
        href: href,
        className: classnames('icon-link', className),
        onClick: onClick
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: "icon-link__icon",
        name: iconName
    }), children)
;

export { IconLink as default };
//# sourceMappingURL=IconLink.js.map
